import { StoreLinkClickProps } from '../../types';
import { Store } from '../../../../types';

export interface IAboutProps {
  className?: string;
  store: Store;
  storeLinkClick: (props: StoreLinkClickProps) => void;
}

export enum DeliveryOptionsTranslationEnum {
  HOME_DELIVERY = 'home-delivery',
}

export type DeliveryOptionsTranslationKey = 'store.home-delivery';
